import script from "./payroll-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-settings.vue?vue&type=script&setup=true&lang=js"

import "./payroll-settings.vue?vue&type=style&index=0&id=b8276ffc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8276ffc"]])

export default __exports__